const getDefaultNavigator = () =>
  typeof navigator === "undefined" ? null : navigator;

const getDefaultDocument = () =>
  typeof document === "undefined" ? null : document;

export const copyTextToClipboard = async (
  value,
  {
    navigatorObject = getDefaultNavigator(),
    documentObject = getDefaultDocument(),
  } = {},
) => {
  const text = String(value == null ? "" : value);

  if (!text) {
    return false;
  }

  if (navigatorObject?.clipboard?.writeText) {
    try {
      await navigatorObject.clipboard.writeText(text);
      return true;
    } catch {
      // Continue with the legacy fallback for non-secure HTTP environments.
    }
  }

  if (
    !documentObject?.body ||
    typeof documentObject.createElement !== "function" ||
    typeof documentObject.execCommand !== "function"
  ) {
    return false;
  }

  const textArea = documentObject.createElement("textarea");

  textArea.value = text;
  textArea.setAttribute("readonly", "");
  textArea.setAttribute("aria-hidden", "true");
  textArea.style.position = "fixed";
  textArea.style.top = "-1000px";
  textArea.style.left = "-1000px";
  textArea.style.opacity = "0";

  documentObject.body.appendChild(textArea);

  try {
    textArea.focus();
    textArea.select();
    textArea.setSelectionRange?.(0, text.length);

    return documentObject.execCommand("copy") === true;
  } catch {
    return false;
  } finally {
    textArea.remove();
  }
};

export default copyTextToClipboard;
